import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  OFFERS_PAGE_PATH,
  OFFERS_PAGE_ADD_PATH,
  OFFERS_PAGE_UPDATE_PATH,
} from "utils/constants/paths";

const OffersDetailsPage = Loadable(React.lazy(() => import("./View")));
const OffersDetailsPageAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate")),
);

export const OffersRoute: IRouteItem = {
  path: OFFERS_PAGE_PATH,
  element: React.createElement(OffersDetailsPage),
  name: "Offers Listing",
  children: [
    {
      name: "Add / Update",
      path: OFFERS_PAGE_ADD_PATH,
      element: React.createElement(OffersDetailsPageAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: OFFERS_PAGE_UPDATE_PATH,
      element: React.createElement(OffersDetailsPageAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
